/** The article's own frontmatter did not parse: `props` describe nothing, and the file is not written back. */
export type FrontmatterFailure = {
	type: "frontmatter";
	message: string;
	/** 1-based line of the file; absent when the native scan, which says only what, found it. */
	line?: number;
};

/** A stand-in answering for a page that is missing or closed, with the status it answers with. */
export type StatusFailure = { type: "status"; code: number };

/** Why an article cannot be shown or written as itself. */
export type ArticleError = FrontmatterFailure | StatusFailure;

export const frontmatterFailure = (message: string | undefined, line?: number): FrontmatterFailure | undefined =>
	message ? { type: "frontmatter", message, line } : undefined;

/** The status a page answers with for an article that cannot be shown as itself. */
export const articleErrorCode = (error: ArticleError | undefined): number | null => {
	if (!error) return null;
	return error.type === "frontmatter" ? 500 : error.code;
};
